module.exports = __webpack_public_path__ + "img/white-logo.504d69d0.png";